import { render, staticRenderFns } from "./CartSideBar.vue?vue&type=template&id=bd4911d2"
import script from "./CartSideBar.vue?vue&type=script&lang=js"
export * from "./CartSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports